// 01-15-2021 note:  created this interface to use as the
//                   call signature for items passed to a
//                   list view, replacing class ListItem

import { IItem } from './iitem.interface';
import { IconFormatEnum } from '../enums/icon-format.enum';

//                   that will now implement this interface.
export interface IListItem extends IItem {
    // Properties.
    itemIndex: number; // pharv - added for row reordering

    setId(idParam: number): void;

    getName(): string;

    getTitle(): string;

    getExtraInfo(): string;

    // pharvey - 10/11/2022 - introduced to provide a flexible way to add columns in a GridView
    // see comment on "Supplying Dynamic Property Values" in grid-view.component.ts on its use
    getValue(property: string): string;

    userCanDelete(): boolean; 

    getPosition(): number;

    modifiedDate: Date;

    modifiedBy: string;

    getStatus(): string;

    getIconType(): IconFormatEnum;
    getIcon(): string;

    // 04-13-2022 note:  no one was using the following method, setIcon().  Also
    //                   removed its NOOP implementation in a number of classes.
    //setIcon(iconParam: string): void;

    canBeDeleted(): boolean;

    update(obj: any, type: string, icon?: string, position?: number): void;

    getUniqueId(): string;

    getOriginalVersionId(): number;

    findAndUpdateFrom(items, obj: any): void;

    isMagicStructure(): boolean;

    getChildCount(): number;

    // pharvey 4/6/22 - Added because now FormInstances have a ModifiedBy and ModifiedByUserName field
    // This allows different implementors to return different fields as they see fit
    getModifiedBy(): string;

    // pharvey 12/29/2022 - added for VNEXT-500 to allow FormInstance's to choose to display their ContentModifiedDate field
    getModifiedDate(): Date;
}

// Define a class that defines one static method, findAndUpdateFrom().
export class IListItemManager {
    public static findAndUpdateFrom(items, obj: any) {
        var filteredItem = items.filter(x => {
            //The explicitType was put in to account for object types that are automatically created with a dash, such as "form-instance". The constructor name will have it as a non-dashed
            //word, such as "FormInstance". This will cause comparing the object type to its constructor name to fail. We can use a property of the object's class, explicitType, to do the comparison
            //return x.id == obj.id && (x.type == obj.constructor.name.toLowerCase() || x.type == obj.explicitType);
            return x.id == obj.id && (x.getType() == obj.constructor.name.toLowerCase() || x.getType() == obj.explicitType);
        });

        if (filteredItem && filteredItem.length > 0) {
            filteredItem[0].update(obj, obj.explicitType ?? obj.constructor.name.toLowerCase());
        }
    }

    private constructor() {
        // Note:  this class cannot be instantiated.
        return;
    }
}
